import React, { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import BorderGradient from 'components/shared/BorderGradient/BorderGradient';
import { FiX } from 'react-icons/fi';
import FormInput from 'components/Project/Form/FormInput';

interface AddParameterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
}

interface FormStateInterface {
  key: string;
  value: string;
}

const AddParameterModal: React.FC<AddParameterModalProps> = ({ isOpen, onClose, onSave }) => {
  const [formState, setFormState] = useState<FormStateInterface>({
    key: "",
    value: "",
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onSave(formState);
    setFormState({
      key: "",
      value: "",
    });
  };

  return (
    <div>
      <Dialog.Root open={isOpen} onOpenChange={onClose}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
          <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] lg:w-[1024px] h-[70vh]">
            <BorderGradient className="rounded-lg flex flex-col h-full w-full">
              <div className="bg-[#1A1A1A] rounded-lg p-6 relative text-white overflow-y-auto flex flex-col h-full">
                <h2 className='text-lg font-semibold'>Add Parameter</h2>
                <button
                  onClick={onClose}
                  className="absolute top-[28px] right-4 text-gray-400 hover:text-white"
                  aria-label="Close"
                >
                  <FiX size={24} />
                </button>
                <div className="mt-5">

                  <FormInput
                    id="key"
                    name="key"
                    value={formState.key}
                    placeholder="key"
                    onChange={handleInputChange}
                  />
                  <FormInput
                    id="value"
                    name="value"
                    value={formState.value}
                    placeholder="Value"
                    onChange={handleInputChange}
                  />

                  <div className="flex justify-end mt-8 gap-5">
                    <button
                      className="flex items-center justify-center text-center gap-2 px-4 py-2 w-[200px] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                      onClick={onClose}>
                      Cancel
                    </button>
                    <button
                      className="flex items-cente justify-center gap-2 px-4 py-2 w-[200px] bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                  </div>

                </div>
              </div>
            </BorderGradient>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  );
};

export default AddParameterModal;
